import React, { FC } from 'react'

const EventCup: FC<DefaultPropsIcon> = ({ size = 72, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 18H11V24C11 32 16 37 23 38" stroke="#15256D" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M54 18H61V24C61 32 56 37 49 38" stroke="#15256D" strokeWidth="2.5" strokeLinecap="round" />
      <path
        d="M18 12H54V25C54 36 46 44 36 46C26 44 18 36 18 25V12Z"
        fill="#309BEC"
        stroke="#15256D"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M22 15H25V28C25 32.7 26.4 36.4 29 39.2C24.7 36.2 21.5 31.1 21.5 24.8V15Z"
        fill="#FFFFFF"
        fillOpacity="0.65"
      />
      <path d="M36 46V56" stroke="#15256D" strokeWidth="3.5" strokeLinecap="round" />
      <path
        d="M30.5 56H41.5C42.9 56 44.2 56.5 45 57.4L48.4 61C49.8 62.5 48.1 64.25 45.7 64.25H26.3C23.9 64.25 22.2 62.5 23.6 61L27 57.4C27.8 56.5 29.1 56 30.5 56Z"
        fill="#309BEC"
        stroke="#15256D"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EventCup
